import styled from 'styled-components';

import PageContentBase from '../../../../components/page-content';

export const Article = styled.article``;

export const PageContent = styled(PageContentBase)`
  @media screen and (min-width: 2056px) {
    margin-left: 0;
  }
`;
